
import axios from 'axios';
import { ENDPOINT } from '../ENDPOINT';

const LeaveService = {
    getActiveLeave: async (uid) => {
        try {
            const response = await axios.get(`${ENDPOINT.leaveRequest}?uid=${uid}`);
            console.log(response)
            return response.data;
        } catch (error) {
            console.error(error);

        }
    },

    getAllLeave: async (uid) => {
        try {
            const response = await axios.get(`${ENDPOINT.leaveRequest}`);
            console.log(response)
            return response.data;
        } catch (error) {
            console.error(error);

        }
    },

    cancelLeave: async (leaveId, payload) => {
        try {
            const response = await axios.put(`${ENDPOINT.leaveRequest}/${leaveId}`, payload);
            return response.data;
        } catch (error) {
            console.error(error);

        }
    },

    createLeaveRequest: async (payload) => {
        try {
            const response = await axios.post(`${ENDPOINT.leaveRequest}`, payload);
            return response.data;
        } catch (error) {
            console.error(error);

        }
    },


    getLeaveType: async () => {
        try {
            const response = await axios.get(`${ENDPOINT.leaveType}/`);
            return response.data;
        } catch (error) {
            console.error(error);

        }
    },

    createLeaveType: async (payload) => {
        try {
            const response = await axios.post(`${ENDPOINT.leaveType}/`, payload);
            return response.data;
        } catch (error) {
            console.error("Error creating leave type:", error);
            throw error;
        }
    },

    updateLeaveType: async (id, payload) => {
        try {
            const response = await axios.put(`${ENDPOINT.leaveType}/${id}/`, payload);
            return response.data;
        } catch (error) {
            console.error("Error updating leave type:", error);
            throw error;
        }
    },

    deleteLeaveType: async (id) => {
    try {
        const response = await axios.delete(`${ENDPOINT.leaveType}/${id}/`);
        return response.data;
    } catch (error) {
        console.error("Error deleting leave type:", error);
        throw error;
    }
},

createEmployeeLeaveType: async (payload) => {
  try {
    const response = await axios.post(`${ENDPOINT.employeedetailsleavetype}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating employee leave type:", error);
    throw error;
  }
},

getEmployeeLeaveTypes: async (userId) => {
    try {
        const response = await axios.get(`${ENDPOINT.employeedetailsleavetype}/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching employee leave types:", error);
        throw error;
    }
},


updateEmployeeLeaveTypes: async (userId, payload) => {
    try {
        const response = await axios.put(
            `${ENDPOINT.employeedetailsleavetype}/${userId}`,
            payload
        );
        return response.data;
    } catch (error) {
        console.error("Error updating employee leave types:", error);
        throw error;
    }
},


 
createEmployeeSalary: async (payload) => {
  try {
    const response = await axios.post(`${ENDPOINT.employeesalary}`, payload);
    
    if (response.data.status) {
      return response.data.data; 
    } else {
      throw new Error(response.data.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error creating employee salary:", error);
    throw error;
  }
},


getEmployeeSalary: async (user_id) => {
  try {
    const response = await axios.get(`${ENDPOINT.employeesalary}/${user_id}`);
    if (response.data.status) {
      return response.data.data;  
    } else {
      throw new Error(response.data.message || "Failed to fetch salary data");
    }
  } catch (error) {
    console.error("Error fetching employee salary:", error);
    throw error;
  }
},



updateEmployeeSalary: async (id, payload) => {
  try {
    const response = await axios.put(`${ENDPOINT.employeesalary}/${id}`, payload);
    console.log("Update response:", response.data); 

    if (response.data.status) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Failed to update salary");
    }
  } catch (error) {
    console.error("Error updating employee salary:", error);
    throw error;
  }
},



deleteEmployeeSalary: async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINT.employeesalary}/${id}`);
    if (response.data.status) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Failed to delete salary");
    }
  } catch (error) {
    console.error("Error deleting employee salary:", error);
    throw error;
  }
}

  










};

export default LeaveService;

